import { useEffect, useState } from "react";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styles } from "../../utils/styles/user-instatement";
import { useRouter } from "next/router";
import { useI18n } from "@/i18n/I18nProvider";
import { useSelector } from "react-redux";
import jsonwebtoken from "jsonwebtoken";
import { EnvKey } from "@/utils/const";
import { FetchUserContract, FetchUserData } from "@/utils/Fetch_userDataFn";
import dynamic from "next/dynamic";
const Inistantapproval = dynamic(() => import("@/components/Inistantapproval"));
const UpComingInstallement = dynamic(() =>
  import("@/components/UpComingInstallement/UpComingInstallement")
);
const PreviousDealing = dynamic(() =>
  import("@/components/PreviousDealing/PreviousDealing")
);
const RemaningAmount = dynamic(() =>
  import("@/components/RemaningAmount/RemaningAmount")
);
const PageHead = dynamic(() => import("@/components/PageHead"));


export default function ContractPage() {
  const [authenticated, setauthenticated] = useState(false);
  const nationalId = useSelector((state) => state.user.nationalId);
  const [Loading, SetLoading] = useState(true);
  const [data, SetData] = useState("");
  const router = useRouter();
  const { t } = useI18n();
  const [ContractData, SetContractData] = useState([]);
  const [flag, SetFlag] = useState(false);
  const [error, setErrMsg] = useState("");
  

  useEffect(() => {
    const token =
      typeof window !== "undefined" && localStorage.getItem("UT_UI");

    if (!token) {
      router.push("/login");
      return;
    }

    try {
      const SessionData = jsonwebtoken.verify(token, EnvKey.secretKey);
      const userId = SessionData.id;

      setauthenticated(true);
      SetFlag(true);

      if (!nationalId) {
        FetchUserData(userId, SetLoading, SetData);
      }

      FetchUserContract(userId, SetLoading, SetContractData, setErrMsg, t);
    } catch (err) {
      localStorage.removeItem("UT_UI");
      router.push("/login");
    }
  }, []);
  if (!flag) {
    return (
      <div className="box-loading" style={{ minHeight: 600 }}>
        <span className="loader"></span>
      </div>
    );
  }

  return (
    <>
      <PageHead />
      {nationalId || data.nationalId ? (
        <Box
          sx={styles.container}
          className="horizontal-safe-padding vertical-safe-padding"
        >
          <Grid container spacing={2} sx={{ mb: "32px" }}>
            <Grid item xs={12} md={3}>
              <RemaningAmount />
            </Grid>
            <Grid item xs={12} md={9}>
              <UpComingInstallement
                contract={ContractData}
                Loading={Loading}
                error={error}
              />
            </Grid>
          </Grid>
          <PreviousDealing contract={ContractData} Loading={Loading} />
        </Box>
      ) : authenticated ? (
        <Inistantapproval Loading={Loading} data={data} flag={flag} />
      ) : null}
    </>
  );
}
